import {FC, useState} from 'react'
import {OrderItemModel} from '../models/OrderItemModel'
import {useIntl} from 'react-intl'
import {LazyLoadImage} from 'react-lazy-load-image-component'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import ItemActionBox from './ItemActionBox'
import './itemGrid.scss'
import {itemStatusClassMapping} from '../utils'
import {selectSelectedItems, selectSelectedMode, setSelectedItem} from '../redux/OrderRedux'
import {useAppSelector} from '../../../../setup/redux/hooks'
import {useDispatch} from 'react-redux'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import {ERROR_ISSUES_DETECTED, ITEM_ISSUES_DETECTED, ItemStatus} from '../constants'
interface Props {
  items: OrderItemModel[]
}
const ItemTable: FC<Props> = (props) => {
  const intl = useIntl()
  const selectMode = useAppSelector(selectSelectedMode)
  const selectedItems = useAppSelector(selectSelectedItems)
  const [targetItem, setTargetItem] = useState<OrderItemModel | undefined>(undefined)
  const [isTargetOuputItem, setIsTargetOuputItem] = useState(true)
  const dispatch = useDispatch()
  const items = props.items
  return (
    <div className='table-responsive'>
      <table className='table text-center'>
        <thead
          style={{
            borderBottom: '1px solid #EFF2F5',
          }}
        >
          <tr>
            {selectMode && <th className='p-0 w-50px'></th>}

            <th className='pl-0 fw-bold text-muted text-uppercase d-flex justify-content-around'>
              <p style={{marginBottom: '0px'}}>
                {intl.formatMessage({id: 'OrderDetail.Form.ITEMS'})}
              </p>
              <p style={{marginBottom: '0px'}}>
                {intl.formatMessage({id: 'OrderDetail.Form.ITEMS_OUTPUT'})}
              </p>
            </th>
            <th className='pl-0 fw-bold text-muted text-uppercase'>
              {intl.formatMessage({id: 'OrderDetail.Form.ITEM_INFO'})}
            </th>
            {/* 
            <th className='text-right pr-0 fw-bold text-muted text-uppercase'>
              {intl.formatMessage({id: 'OrderDetail.Form.ITEM_PRICE'})}
            </th>
            <th className='text-right pr-0 fw-bold text-muted text-uppercase'>
              {intl.formatMessage({id: 'OrderDetail.Form.ITEM_STATUS'})}
            </th> */}
            <th className='text-right pr-0 fw-bold text-muted text-uppercase'>
              {intl.formatMessage({id: 'OrderDetail.Form.ITEM_ACTION'})}
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((item: OrderItemModel) => {
            const detectedIssues = item.note
              ? item.note
                  .split(',')
                  .map((noteText) => noteText.trim())
                  .filter((noteText) => ITEM_ISSUES_DETECTED.includes(noteText))
              : []
            const hasErrorIssue = detectedIssues.some((issue) =>
              ERROR_ISSUES_DETECTED.includes(issue)
            )
            let outputImageUrl = toAbsoluteUrl('/media/loading-bg.gif')
            switch (item.status) {
              case ItemStatus.FAIL:
                outputImageUrl =
                  item.outputImageUrl?.tiny ??
                  item.inputImageUrl?.tiny ??
                  toAbsoluteUrl('/media/loading-bg.gif')
                break
              case ItemStatus.DONE:
                outputImageUrl = item.outputImageUrl?.tiny ?? toAbsoluteUrl('/media/loading-bg.gif')
                break
              case ItemStatus.PENDING:
                outputImageUrl = item.outputImageUrl?.tiny ?? toAbsoluteUrl('/media/loading-bg.gif')
                break
              default:
                outputImageUrl = toAbsoluteUrl('/media/loading-bg.gif')
            }
            // If item is in AI_PROCESSING state and has detected issues, show warning icon
            return (
              <tr key={item.id} className='fw-bold fs-6 border-bottom-0'>
                {selectMode && (
                  <td className='align-middle'>
                    <div className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        className='form-check-input widget-9-check'
                        type='checkbox'
                        checked={selectedItems.includes(item.id)}
                        disabled={item.status !== ItemStatus.DONE}
                        value={item.id}
                        onChange={() => {
                          dispatch(
                            setSelectedItem({id: item.id, isAdd: !selectedItems.includes(item.id)})
                          )
                        }}
                      />
                    </div>
                  </td>
                )}
                <td
                  style={{margin: 'auto'}}
                  className='align-middle order-item-row justify-content-between d-flex rotate'
                >
                  <div
                    onClick={() => {
                      if (item.inputImageUrl) {
                        setIsTargetOuputItem(false)
                        setTargetItem(item)
                      }
                    }}
                  >
                    <LazyLoadImage
                      effect='blur'
                      placeholderSrc={toAbsoluteUrl('/media/loading-bg.gif')}
                      src={item.inputImageUrl?.tiny}
                      onError={(event: any) => {
                        if (event?.target?.src)
                          event.target.src = toAbsoluteUrl('/media/loading-bg.gif') // Replace with your default image URL
                      }}
                    />
                  </div>
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr024.svg'
                    className='rotate-180 svg-icon-success svg-icon-2hx mx-auto'
                  />
                  <div
                    style={{position: 'relative'}}
                    onClick={() => {
                      if (item.outputImageUrl) {
                        setIsTargetOuputItem(true)
                        setTargetItem(item)
                      }
                    }}
                  >
                    <LazyLoadImage
                      effect='blur'
                      placeholderSrc={toAbsoluteUrl('/media/loading-bg.gif')}
                      src={outputImageUrl}
                      onError={(event: any) => {
                        if (event?.target?.src) {
                          setTimeout(() => {
                            event.target.src = outputImageUrl // Replace with your default image URL
                          }, 1000)
                          event.target.src = toAbsoluteUrl('/media/loading-bg.gif')
                        }
                      }}
                    />

                    {/* Issue icon for items with detected issues - danger color for blocking issues */}
                    {detectedIssues.length > 0 && (
                      <i
                        className={`bi ${
                          hasErrorIssue
                            ? 'bi-exclamation-octagon-fill text-danger'
                            : 'bi-exclamation-triangle-fill text-warning'
                        }`}
                        style={{
                          position: 'absolute',
                          top: '2px',
                          right: '2px',
                          fontSize: '1rem',

                          borderRadius: '50%',
                          padding: '2px',
                          cursor: 'help',
                          zIndex: 10,
                        }}
                        title={intl.formatMessage({id: 'ITEM.WARNING.PROCESSING_ISSUE'})}
                      ></i>
                    )}
                  </div>
                </td>
                <td className='border-top-0 py-4 align-middle text-wrap '>
                  <div className='d-flex flex-column align-middle'>
                    <Link
                      to={'/orders/' + item.orderId + '/items/' + item.id}
                      className='text-dark fw-bolder text-hover-primary fs-6 mb-1'
                    >
                      {item.name}
                    </Link>
                    <span>
                      {' '}
                      {item.price} {intl.formatMessage({id: 'Item.Credit'})}
                    </span>
                    <span
                      className={`badge ${itemStatusClassMapping(
                        item.status
                      )} fw-bolder mt-1 mx-auto px-4 py-3`}
                    >
                      {intl.formatMessage({id: 'Item.status.' + item.status})}
                    </span>

                    {/* Warning badges for AI_PROCESSING items with notes */}
                    {detectedIssues.length > 0 && (
                      <div className='mt-2'>
                        {detectedIssues.map((noteText, index) => {
                          const hasErrorIssue = ERROR_ISSUES_DETECTED.includes(noteText.trim())

                          return (
                            <span
                              key={index}
                              className={`badge ${
                                hasErrorIssue ? 'badge-danger' : 'badge-warning'
                              } fw-bolder me-1 mb-1 px-2 py-1`}
                              style={{fontSize: '0.75rem'}}
                            >
                              {intl.formatMessage({id: `ITEM.ISSUE.${noteText.trim()}`})}
                            </span>
                          )
                        })}
                      </div>
                    )}
                  </div>
                </td>

                {/* <td className='text-primary border-top-0 pr-0 py-4 align-middle'>{item.price}</td>
              <td className='border-top-0 py-4 align-middle'>
                <span
                  className={`badge ${itemStatusClassMapping(
                    item.status
                  )} fw-bolder me-auto px-4 py-3`}
                >
                  {intl.formatMessage({id: 'Item.status.' + item.status})}
                </span>
              </td> */}
                <td className='align-middle'>
                  <ItemActionBox item={item} />
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      {targetItem && (targetItem.outputImageUrl || targetItem.inputImageUrl) && (
        <Lightbox
          mainSrc={
            isTargetOuputItem
              ? (targetItem.outputImageUrl?.medium as string)
              : (targetItem.inputImageUrl?.medium as string)
          }
          nextSrc={isTargetOuputItem ? undefined : targetItem.inputImageUrl?.medium}
          prevSrc={isTargetOuputItem ? targetItem.outputImageUrl?.medium : undefined}
          onMovePrevRequest={() => setIsTargetOuputItem(false)}
          onMoveNextRequest={() => setIsTargetOuputItem(true)}
          onCloseRequest={() => setTargetItem(undefined)}
        />
      )}
    </div>
  )
}

export default ItemTable
